/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiCallSourceFromJSON, StreemApiCallSourceToJSON, } from './';
export function StreemApiGetCompanyCallSourcesResponseFromJSON(json) {
    return StreemApiGetCompanyCallSourcesResponseFromJSONTyped(json, false);
}
export function StreemApiGetCompanyCallSourcesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'callSources': !exists(json, 'call_sources') ? undefined : (json['call_sources'].map(StreemApiCallSourceFromJSON)),
    };
}
export function StreemApiGetCompanyCallSourcesResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'call_sources': value.callSources === undefined ? undefined : (value.callSources.map(StreemApiCallSourceToJSON)),
    };
}
//# sourceMappingURL=StreemApiGetCompanyCallSourcesResponse.js.map